// third party host
const assetsHost = ''

export const getAssetFullPath = (value: string) => {
    return assetsHost + value
}

export const passwordComplexityCheck = (value: string): boolean => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,128}$/
    const isValid = regex.test(value)
    return isValid
}

// blocks > defenders, midfield, attack

//type Block = 'defenders' | 'midfielders' | 'forwards' | 'goalKeeper'

export const findoutBlockFromPosition = (position: string): string => {
    if (position.endsWith('B')) return 'defenders'
    else if (position.endsWith('M')) return 'midfielders'
    else if (position.endsWith('T') || position.endsWith('S') || position.endsWith('F')) return 'forwards'
    else if (position === 'GK') return 'goalKeeper'
    console.warn(`Position ${position} is not valid`)
    return ''
}

const blockColors: {
    [K in string]: string
} = {
    forwards: '#881220',
    midfielders: '#3e9173',
    defenders: '#a9462c',
    goalKeeper: '#9656bc'
}

export const getBlockColor = (block: string) => {
    return blockColors[block]
}

export const findGoalKeepr = (positions: IPosition[]): IPosition => {
    const goalKeeper = positions.find(position => position.position === 'GK')
    if (goalKeeper) return goalKeeper
    else throw new Error('GK does not exist in provided positions')
}

interface Players {
    goalKeeper: IPosition[]
    defenders: IPosition[]
    midfielders: IPosition[]
    forwards: IPosition[]
}

export const createPlayers = (positions: IPosition[]): Players => {
    const players: Players = {
        goalKeeper: [],
        defenders: [],
        midfielders: [],
        forwards: []
    }

    positions.forEach(position => {
        const block = findoutBlockFromPosition(position.position)
        switch (block) {
            case 'goalKeeper':
                players.goalKeeper.push(position)
                break
            case 'defenders':
                players.defenders.push(position)
                break
            case 'midfielders':
                players.midfielders.push(position)
                break
            case 'forwards':
                players.forwards.push(position)
                break
        }
    })

    return players
}
